import { BaseQueryFn, MutationDefinition } from "@reduxjs/toolkit/dist/query";
import { MutationTrigger } from "@reduxjs/toolkit/dist/query/react/buildHooks";
import { useAppDispatch } from "./store";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { showNotification } from "../store/reducers";
import { IMessageResponse } from "../shared";

type IHandleCancel<ApiName extends string> = MutationTrigger<
  MutationDefinition<
    string,
    BaseQueryFn<
      {
        url: string;
        method: string | undefined;
        data?: any;
        params?: any;
      },
      unknown,
      unknown
    >,
    ApiName,
    IMessageResponse,
    ApiName
  >
>;
export const useHandleCancel = <ApiName extends string>(
  handleCancel: IHandleCancel<ApiName>
) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [id, setId] = useState<string>("");

  const handleConfirmCancel = async () => {
    try {
      await handleCancel(id).unwrap();
      setIsConfirmOpen(false);
      dispatch(
        showNotification({
          type: "success",
          message: t("alert.successfulCancel"),
        })
      );
    } catch (error: any) {
      dispatch(
        showNotification({
          type: "error",
          message: t([
            `alert.errors.${error.data.message}`,
            `alert.errors.${error.data.response?.message}`,
            "alert.somethingWentWrong",
          ]),
        })
      );
    }
  };

  const handleCancelCancel = () => {
    setIsConfirmOpen(false);
  };

  const onCancel = (id: string) => {
    setId(id);
    setIsConfirmOpen(true);
  };

  return {
    isConfirmOpen,
    handleConfirmCancel,
    handleCancelCancel,
    onCancel,
  };
};
